const topicsJSON = {
  'Culture & Language': { 933: 'Cross-Cutting Approaches' },
  'Data & Ongoing Monitoring': { 933: 'Cross-Cutting Approaches' },
  'Professional Development': { 933: 'Cross-Cutting Approaches' },
  'School Readiness': { 933: 'Cross-Cutting Approaches' },
  'State Systems': { 933: 'Cross-Cutting Approaches' },
  'Child Screening & Assessment': { 934: 'Education & Child Development' },
  'Children with Disabilities': { 934: 'Education & Child Development' },
  'Curriculum': { 934: 'Education & Child Development' },
  'Learning Environments': { 934: 'Education & Child Development' },
  'Teaching Practices': { 934: 'Education & Child Development' },
  'Transitions': { 934: 'Education & Child Development' },
  'Community Engagement': { 935: 'Family & Community' },
  'Family Engagement': { 935: 'Family & Community' },
  'Family Support & Well-being': { 935: 'Family & Community' },
  'Local Early Childhood Partnerships': { 935: 'Family & Community' },
  'Parenting': { 935: 'Family & Community' },
  'Pregnancy': { 935: 'Family & Community' },
  'Health Services Management': { 936: 'Health' },
  'Mental Health': { 936: 'Health' },
  'Nutrition': { 936: 'Health' },
  'Oral Health': { 936: 'Health' },
  'Physical Health': { 936: 'Health' },
  'Safety Practices': { 936: 'Health' },
  'Eligibility (ERSEA)': { 937: 'Program Management' },
  'Facilities': { 937: 'Program Management' },
  'Fiscal Management': { 937: 'Program Management' },
  'Human Resources': { 937: 'Program Management' },
  'Organizational Leadership': { 937: 'Program Management' },
  'Program Planning': { 937: 'Program Management' },
  'Transportation': { 937: 'Program Management' },
  'Federal Administrative Procedures': { 937: 'Program Management' },
  'Designation Renewal System': { 937: 'Program Management' },
  'Federal Monitoring': { 937: 'Program Management' },
  'Grant Application': { 937: 'Program Management' }
}
